import { SendDownloadLinksFormBaseDataProvider } from './SendDownloadLinksFormBaseDataProvider';

export class SendDownloadLinksFormDataProvider extends SendDownloadLinksFormBaseDataProvider {}
